"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
class LocalStorage {
    constructor(location) {
        throw new Error("Do not call me");
    }
}
exports.LocalStorage = LocalStorage;
